import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

export default function SearchesHeader({ userId, userProfile }) {
  const [currentMonthUsage, setCurrentMonthUsage] = useState(0)

  useEffect(() => {
    if (userId) {
      loadCurrentMonthUsage()
    }
  }, [userId, userProfile])

  async function loadCurrentMonthUsage() {
    try {
      const now = new Date()
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1)

      const { data, error, count } = await supabase
        .from('analyses')
        .select('*', { count: 'exact', head: false })
        .eq('user_id', userId)
        .gte('created_at', startOfMonth.toISOString())

      if (error) {
        console.error('[SearchesHeader] Error loading current month usage:', error)
        return
      }

      const usage = count !== null ? count : (data?.length || 0)
      console.log('[SearchesHeader] Current month usage:', usage)
      setCurrentMonthUsage(usage)
    } catch (err) {
      console.error('[SearchesHeader] Unexpected error loading usage:', err)
    }
  }

  if (!userProfile) return null

  const isAdmin = userProfile.role === 'admin'
  const isPremium = userProfile.is_premium
  const limit = isPremium ? 50 : userProfile.queries_limit || 5
  const used = userProfile.queries_used || 0
  const percentage = isAdmin ? 100 : (used / limit) * 100

  return (
    <div
      style={{
        padding: '12px 20px',
        background: 'rgba(34, 139, 34, 0.2)',
        borderBottom: '2px solid rgba(152, 251, 152, 0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        flexWrap: 'wrap'
      }}
      role="status"
      aria-label={`Remaining searches: ${isAdmin ? 'Unlimited' : `${used} of ${limit}`}`}
    >
      <div style={{
        fontFamily: 'Cousine, monospace',
        fontSize: '14px',
        color: '#98FB98',
        textShadow: '0 0 8px rgba(152, 251, 152, 0.5)',
        fontWeight: '600'
      }}>
        {isAdmin ? (
          <span>Remaining Searches: Unlimited</span>
        ) : (
          <span>Remaining Searches: {used}/{limit}</span>
        )}
      </div>

      {!isAdmin && (
        <div style={{
          width: '200px',
          height: '12px',
          background: '#228B22',
          borderRadius: '6px',
          overflow: 'hidden',
          border: '1px solid #98FB98',
          boxShadow: '0 0 10px rgba(152, 251, 152, 0.3)'
        }}>
          <div
            style={{
              width: `${Math.min(percentage, 100)}%`,
              height: '100%',
              background: 'linear-gradient(90deg, #98FB98, #7CFC00)',
              transition: 'width 0.3s ease',
              boxShadow: '0 0 10px rgba(152, 251, 152, 0.6)'
            }}
            role="progressbar"
            aria-valuenow={used}
            aria-valuemin={0}
            aria-valuemax={limit}
          />
        </div>
      )}
    </div>
  )
}
